import { FONT_SIZES } from '../../../constants/sizes.js';

const getTextSize = (size) => {
    switch (size) {
        case 60:
            return FONT_SIZES.S20;
        case 36:
        case 44:
        case 52:
        default:
            return FONT_SIZES.S16;
    }
};

export { getTextSize };
//# sourceMappingURL=getTextSize.js.map
